import { render, staticRenderFns } from "./modalCreateService.vue?vue&type=template&id=8e6216b2&scoped=true&"
import script from "./modalCreateService.vue?vue&type=script&lang=js&"
export * from "./modalCreateService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6216b2",
  null
  
)

export default component.exports